import { render, staticRenderFns } from "./mnExamDetail.vue?vue&type=template&id=f54cca50&scoped=true"
import script from "./mnExamDetail.vue?vue&type=script&lang=js"
export * from "./mnExamDetail.vue?vue&type=script&lang=js"
import style0 from "./mnExamDetail.vue?vue&type=style&index=0&id=f54cca50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54cca50",
  null
  
)

export default component.exports